import { observer } from "mobx-react-lite";
import { useState } from "react";
import { Button, message } from "antd";
import { globalModel } from "../../global/GlobalModel";
import { membershipRetailPurchaseState } from "../../products/membership/membershipPurchaseUtils";
import { membershipNoRetailPurchaseHint } from "../../platform_spaces/space/spacePageUtils";
import type { MembershipProduct } from "../../platform_spaces/space/SpaceType";
import { StandaloneProductPurchaseModal } from "../purchase/StandaloneProductPurchaseModal";
import { StandaloneStrategyProductPurchaseModal } from "../purchase/StandaloneStrategyProductPurchaseModal";

type Props = {
  row: MembershipProduct;
};

/** 独立站产品页：海报上的订阅按钮 + 独立站购买弹窗 */
export const StandaloneProductSubscribeCta = observer((props: Props) => {
  const { row } = props;
  const [purchaseOpen, setPurchaseOpen] = useState(false);
  const { isStrategyTool, canBuyRetail } = membershipRetailPurchaseState(row);

  const openPurchaseModal = () => {
    if (!globalModel.isLoggedIn) {
      globalModel.openLoginModal();
      return;
    }
    if (!canBuyRetail) {
      message.info(membershipNoRetailPurchaseHint(row));
      return;
    }
    setPurchaseOpen(true);
  };

  return (
    <>
      <div className="space-m-purchase-col">
        {canBuyRetail ? (
          <Button
            type="primary"
            className="space-access-gate__subscribe-btn"
            onClick={openPurchaseModal}
          >
            订阅
          </Button>
        ) : (
          <span className="space-m-no-spec-hint">
            {membershipNoRetailPurchaseHint(row)}
          </span>
        )}
      </div>
      {isStrategyTool ? (
        <StandaloneStrategyProductPurchaseModal
          row={row}
          open={purchaseOpen}
          onClose={() => setPurchaseOpen(false)}
        />
      ) : (
        <StandaloneProductPurchaseModal
          row={row}
          open={purchaseOpen}
          onClose={() => setPurchaseOpen(false)}
        />
      )}
    </>
  );
});
